import React from 'react';
import { connect } from 'react-redux';
import './AgreementLanding.css';
import HowItWorks from './HowItWorks';
import usePageAnchor from './usePageAnchor';

function How({ hash }) {
  usePageAnchor(hash);
  return (
    <main className="agreementHome">
      <HowItWorks headingTag="h1" />
    </main>
  );
}

export default connect(state => ({ hash: state.menu.hash }))(How);
